import Vue from 'vue';
import Vuex, {ActionContext, Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {DateFilter, NumberFilter} from '@/shared/filter';
import {
	PaginatorActionWithFilters,
	PaginatorFilterState,
	PaginatorMutationFilter,
	StandardAction
} from '@/shared/utils';
import {Commande, BoisType, Fournisseur, LongueursVente, Pile, Client, Vente} from '@/models';
import {CommandeService} from '@/xhttp';
import store from '@/stores';
import {storeVentesTotaux} from "@/stores/modules/vente";

Vue.use(Vuex);

export class CommandeFilter {

	client: Client[] = [];
	boisType: BoisType[] = [];
	longueursVente: LongueursVente[] = [];
	remainingTrucks: number[] = [];

	public clear(): void {
		this.client = [];
		this.boisType = [];
		this.longueursVente = [];
		this.remainingTrucks = [];
	}

	public toString(): string {
		return JSON.stringify({
			client    : this.client.map(t => t.id),
			boisType    : this.boisType.map(t => t.id),
			longueursVente    : this.longueursVente.map(t => t.id),
			remainingTrucks	: this.remainingTrucks,
		});

	}
}

class CommandeState extends PaginatorFilterState<CommandeFilter> {
	public commande: Commande = null;
	public commandes: ResultType<Commande> = null;
	public constructor() {
		super(new CommandeFilter(), 'commandes', 'commande', 'id', AscDesc.DESC, 50);
	}
}

class CommandeStore {
	
	@XHTTPService(() => Commande)
	private commandeService: CommandeService;
	private  _store: Store<any>;
	
	public state: CommandeState = new CommandeState();
	
	public mutations = {
		...PaginatorMutationFilter(() => storeCommande, 'commandes', 'commande'),
	};
	
	public actions = {
		...PaginatorActionWithFilters<Commande, CommandeState>(() => Commande, 'commandes', 'commande'),
		...StandardAction<Commande, CommandeState>(() => Commande, 'commande'),

		async getCommandes(context: ActionContext<CommandeState, any>): Promise<ResultType<Commande>> {
			const commandeResult = await instance.commandeService.getCommandes();
			context.commit('setCommandes', commandeResult);
			return commandeResult;
		},
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}
	
}

const instance = new CommandeStore();
const storeCommande = new Vuex.Store(instance);
instance.init(storeCommande);

const instanceHistorique = new CommandeStore();
export const storeCommandeHistorique = new Vuex.Store(instanceHistorique);
instanceHistorique.init(storeCommandeHistorique);

store.registerModule('commande', storeCommande);
store.registerModule('commandeHistorique', storeCommandeHistorique);
export default storeCommande;
